<template>
  <img v-if="imgSrc" :src="imgSrc" style="width:100%; height: 150px; " />
</template>
<script setup lang="ts">
import {computed} from "vue";
import {extractSupportedThumbnailFromUrl} from "@/utils/thumbnail.util";
export interface PreviewThumbnailProps {
  url: string
}

const props = defineProps<PreviewThumbnailProps>()
const imgSrc = computed(() => extractSupportedThumbnailFromUrl(props.url))
</script>
<style>
</style>